import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withExperimentalAutoCleanupInjectors,
} from '@angular/router';
import { appRoutes } from '../app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { ErrorInterceptor, TokenInterceptor } from '@tnq/shared/core';
import {
  SharedConfigModule,
  TranslationConfigModule,
} from '@tnq/shared/config';
import { environment } from '../../environments/environment';
import { config } from './config';
import { SUI_BUTTON_DEFAULT, SUI_FIELD_CONFIG } from '@stride-ui/components';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Without this, a store provided on a route keeps its data and filters
    // after the page is left.
    // TODO: switch to withAutoCleanupInjectors() when upgrading to Angular
    // 22.2, where this experimental name is deprecated.
    provideRouter(appRoutes, withExperimentalAutoCleanupInjectors()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: SUI_BUTTON_DEFAULT, useValue: { radius: 'full', size: 'xl' } },
    { provide: SUI_FIELD_CONFIG, useValue: { size: 'xl' } },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    importProvidersFrom(
      SharedConfigModule.register({ env: environment, config }),
      TranslationConfigModule.register({
        path: 'assets/i18n/',
        locales: config.languageOptions,
      }),
    ),
  ],
};
